<template>
  <!-- 提示 -->
  <div class="prompts" id="prompts"  :style="opacity == true?'opacity:0.7':''">
    <div class="informarion">{{ titleinformarion }}</div>
    <div v-show="informarion!=''">{{ informarion }}</div>
  </div>
</template>

<script>
export default {
  props: ["titleinformarion", "informarion", "opacity"],
updated(){
    // if(this.opacity==true){
    //   var timer = setTimeout(function () {
    //         console.log(2);
    //           this.opacity = false;
    //        var proo=  document.getElementById("proo")
    //         console.log(proo);
    //         proo.style.opacity=0

    //     clearInterval(timer);
    //   }, 3000);
    // }

},
  methods:{

  }
};
</script>

<style>
.prompts {
  background-color: black;
  opacity: 0;
  width: 200px;
  height: 80px;
  z-index: 101;
  position: fixed;
  /* background: rgba(0, 0, 0, 0.6); */
  top: 28%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 100;
  display: block;
  border-radius: 5px;
  color: white;
  text-align: center;
}
.informarion {
  font-size: 20px;
  text-align: center;
  margin-top: 20px;
}
</style>